import { UserRoles } from "../graphql/__GENERATED__/types";
import { TModelFilters } from "./deprecated.types";

const partnersFilters: TModelFilters = [
  {
    value: "consultores",
    name: "Consultores",
    filter: {
      role: UserRoles.Consultant,
    },
    nestedFilters: [
      {
        value: "registered",
        name: "Cadastrados",
        filter: {
          status: "registered",
          disabled: { $ne: true },
        },
      },
      {
        value: "approved",
        name: "Aprovados",
        filter: {
          status: "approved",
          disabled: { $ne: true },
        },
      },
      {
        value: "rejected",
        name: "Recusados",
        filter: {
          status: "rejected",
          disabled: { $ne: true },
        },
      },
      {
        value: "active",
        name: "Ativos",
        filter: {
          status: "active",
          disabled: { $ne: true },
        },
      },
      {
        value: "disabled",
        name: "Desabilitados",
        filter: {
          disabled: true,
        },
      },
    ],
  },
];

export default partnersFilters;
